import { Typography, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './CheckDetailTitle'
import TimelineDotLine from '../components/TimelineDotLine'
import CheckRiskStatus from '../components/CheckRiskStatus'
import './checks.scss'

const CheckCeaf = ({ ceafCheck, level = 0 }) => {
  const { t } = useTranslation(['common', 'messages'])

  const hasArrayChecks = Array.isArray(ceafCheck?.checkDetails) && ceafCheck.checkDetails.length > 0
  const hasObjectCheck =
    !Array.isArray(ceafCheck?.checkDetails) && ceafCheck.found && Object.keys(ceafCheck?.checkDetails || {}).length > 0
  const checkLength = hasArrayChecks ? ceafCheck.checkDetails.length : hasObjectCheck ? 1 : 0

  return (
    <>
      <Paper elevation={0} variant="rootOutlined" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{t('common:ceis')}</Typography>
        <CheckRiskStatus checkLength={checkLength} hasChecks={checkLength > 0} />
      </Paper>

      <CheckDetailTitle
        email={ceafCheck?.email}
        status={ceafCheck?.status}
        createdAt={ceafCheck?.createdAt}
        updatedAt={ceafCheck?.updatedAt}
      />

      {hasObjectCheck && ceafCheck?.informação && (
        <Paper elevation={0} sx={{ flex: 1, mt: 2 }}>
          <div className="c-detail-row">
            <Typography variant="subtitle1">{t('common:information')}</Typography>
            <Typography variant="subtitle3">{ceafCheck.informação}</Typography>
          </div>
        </Paper>
      )}

      {hasArrayChecks &&
        ceafCheck.checkDetails.map((element, index) => (
          <TimelineDotLine key={index}>
            <Paper elevation={0} sx={{ flex: 1 }}>
              <div className="c-detail-grid">
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:initialDate')}</Typography>
                  <Typography variant="subtitle3">{element.dataPublicacao ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">Reference</Typography>
                  <Typography variant="subtitle3">{element.dataReferencia ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:sanctionDescription')}</Typography>
                  <Typography variant="subtitle3">{element.tipoPunicao?.descricao ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:sanctioningBody')}</Typography>
                  <Typography variant="subtitle3">{element.orgaoLotacao?.nome ?? '---'}</Typography>
                </div>
              </div>
            </Paper>
          </TimelineDotLine>
        ))}
    </>
  )
}

export default CheckCeaf

/* import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './CheckDetailTitle'

const variantByLevel = {
  0: 'h3',
  1: 'h4',
}

const CheckCeaf = ({ title = '', ceafCheck, level = 0 }) => {
  const { t } = useTranslation(['common', 'messages'])
  return (
    <Box className="detail-group">
      <Typography variant={variantByLevel[level] || variantByLevel[0]}>{title || 'CEIS'}</Typography>
      <CheckDetailTitle
        email={ceafCheck?.email}
        status={ceafCheck?.status}
        createdAt={ceafCheck?.createdAt}
        updatedAt={ceafCheck?.updatedAt}
      />
      {!Array.isArray(ceafCheck?.checkDetails) && Object.keys(ceafCheck?.checkDetails).length && (
        <Box>
          <Box>
            <span>{t('common:information')}</span>
            <p>{ceafCheck.informação ?? '---'}</p>
          </Box>
        </Box>
      )}
      {Array.isArray(ceafCheck?.checkDetails) && ceafCheck?.checkDetails.length && (
        <Box>
          <h4>{t('common:sanctions')}</h4>
          <Box className="group-table">
            <table className="bs bst group-table">
              <thead>
                <tr className="group-table">
                  <th className="bs">{t('common:initialDate')}</th>
                  <th className="bs">Reference</th>
                  <th className="bs">{t('common:sanctionDescription')}</th>
                  <th className="bs">{t('common:sanctioningBody')}</th>
                </tr>
              </thead>
              <tbody>
                {ceafCheck?.checkDetails?.map((element, index) => {
                  return (
                    <tr className="group-table" key={index}>
                      <td className="bs table-cell col-4">{element.dataPublicacao ?? '---'}</td>
                      <td className="bs table-cell col-4">{element.dataReferencia ?? '---'}</td>
                      <td className="bs table-cell col-4">{element.tipoPunicao?.descricao ?? '---'}</td>
                      <td className="bs table-cell col-4">{element.orgaoLotacao?.nome ?? '---'}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default CheckCeaf
 */
